import { Box, Button, MenuItem, Menu, CardMedia } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import LinkHI from "./Link";
import { useDispatch, useSelector } from "react-redux";
import { makeStyles } from "@material-ui/styles";
import { useHistory } from "react-router";
import { deleteSelection } from "src/api/api";
import { clearPatient, setHearingDevice } from "src/actions/patientActions";
import Save from "./Save";

const useStyles = makeStyles(theme => ({
	media1: {
		height: 30,
		width: 30,
		textAlign: "center",
		lineHeight: "30px",
		boxShadow: `0 0 2px 2px ${theme.palette.primary.main}`,
		margin: "0 3px"
	},
	outline: {
		height: 30,
		width: 30,
		textAlign: "center",
		lineHeight: "42px",
		outline: `1px solid ${theme.palette.primary.main}`,
		margin: "0 3px"
	},
	linkImage: {
		width: "30px",
		height: "30px"
	},
	barBg: {
		display: "flex",
		borderRadius: "15px",
		border: `1px solid ${theme.palette.background.link}`,
		padding: "0 2%",
		justifyContent: "space-around",
		background: theme.palette.background.link
	}
}));

const initialState = {
	mouseX: null,
	mouseY: null
};

let deleteSide;

const PROGRAM_IMGS = ["Noah", "Noah", "Noah", "remote", "Noahwireless"];

export default function LinkBar() {
	const { hearingDeviceSettingRight, hearingDeviceSettingLeft } = useSelector(
		state => state.patient
	);
	const [linkData, setLinkData] = useState({
		start: false,
		isLinkHi: true,
		hasPackage: true,
		training: false
	});
	const classes = useStyles();
	const history = useHistory();
	const dispatch = useDispatch();
	const [state, setState] = React.useState(initialState);
	const [currentDeviceType, setCurrentDeviceType] = useState(1);
	const [leftStatus, setLeftStatus] = useState(null); //-1,0,1,2
	const [rightStatus, setRightStatus] = useState(null); //-1,0,1,2
	const [
		fittingDeviceConnectionStatus,
		setFittingDeviceConnectionStatus
	] = useState(() => ({
		status: -1,
		msg: "",
		success: false
	}));
	const { t, i18n } = useTranslation();
	const handleClick = e => {
		let type = e.target.getAttribute("data-type");
		if (type === "1") {
			history.push("/app/devices/hearingInstrument-detail");
		} else if (type === "2") {
			history.push("/app/devices/hearingInstrument");
		}
	};

	const handleDelete = () => {
		setState(initialState);
		if (deleteSide) {
			deleteSelection(deleteSide).then(res => {
				dispatch(clearPatient(deleteSide));
				deleteSide = null;
			});
		}
	};

	const handleContextMenu = (event, side) => {
		event.preventDefault();
		deleteSide = side;
		setState({
			mouseX: event.clientX - 2,
			mouseY: event.clientY - 4
		});
	};
	const linkHiTest = () => {
		setLinkData({
			start: true,
			isLinkHi: true,
			hasPackage: true,
			training: true
		});
	};
	const linkHi = () => {
		setLinkData({
			start: true,
			isLinkHi: true,
			hasPackage: true,
			training: false
		});
	};
	const linkProgram = () => {
		setLinkData({ start: true, isLinkHi: false, hasPackage: true });
	};

	const getHiImg = (status = -1, type) => {
		if (status > 1 && status <= 6) return "linking.gif";
		else if (status === 9) return "error.png";
		else if (status === 7) return "link.png";
		else return "unlink.png";
	};
	const getProgramImg = (state = -1) => {
		if (state === 0) {
			return "linking.gif";
		} else if (state === 1) {
			return "link.png";
		} else if (state === 2) {
			return "error.png";
		} else {
			return "unlink.png";
		}
	};

	useEffect(() => {
		if (!hearingDeviceSettingLeft && !hearingDeviceSettingRight) {
			dispatch(setHearingDevice("all"));
		}
	}, []);

	return (
		<Box
			ml={2}
			flex={1}
			display="flex"
			justifyContent="center"
			alignItems="center"
			position="relative"
		>
			{/* {hearingDeviceSettingRight ? (
				<CommonCardMedia
					imageUrl={hearingDeviceSettingRight?.picture?.imageUrl}
					isReverse={hearingDeviceSettingRight?.picture?.isReverse}
					data-type="1"
					className={classes.media1}
					onClick={handleClick}
					onContextMenu={e => handleContextMenu(e, "right")}
					style={{ cursor: "context-menu" }}
				/>
			) : (
				<div className={classes.outline}>
					<AddIcon onClick={handleClick} data-type="2" style={{ color: Red }} />
				</div>
			)}
			{hearingDeviceSettingLeft ? (
				<CardMedia
					className={classes.media1}
					image={hearingDeviceSettingLeft?.picture?.imageUrl}
					data-type="1"
					onClick={handleClick}
					onContextMenu={e => handleContextMenu(e, "left")}
					style={{ cursor: "context-menu" }}
				/>
			) : (
				<div className={classes.outline}>
					<AddIcon
						onClick={handleClick}
						data-type="2"
						style={{ color: Blue }}
					/>
				</div>
			)} */}
			<Box className={classes.barBg}>
				<Button>
					<CardMedia
						className={classes.linkImage}
						image="/static/images/link/sound/no-sound.png"
					/>
				</Button>
				<Button>
					<CardMedia
						className={classes.linkImage}
						image={`/static/images/link/hi/earar/${getHiImg(
							rightStatus?.state
						)}`}
					/>
				</Button>
				<Button onClick={linkProgram}>
					<CardMedia
						className={classes.linkImage}
						image={`/static/images/link/program/${
							PROGRAM_IMGS[currentDeviceType - 1]
						}/${getProgramImg(fittingDeviceConnectionStatus.status)}`}
					/>
				</Button>
				<Button>
					<CardMedia
						className={classes.linkImage}
						image={`/static/images/link/hi/earar/${getHiImg(
							leftStatus?.state
						)}`}
					/>
				</Button>
				<Button>
					<CardMedia
						style={{ transform: "scaleX(-1)" }}
						className={classes.linkImage}
						image="/static/images/link/sound/no-sound.png"
					/>
				</Button>
			</Box>
			{/* <Button
				size="small"
				variant="contained"
				color="secondary"
				style={{ position: "absolute", right: "5%" }}
			>
				删除
			</Button> */}
			<Box position="absolute" right="5%" display="flex" alignItems="center">
				<Button
					size="small"
					variant="contained"
					onClick={linkHiTest}
					color="primary"
					style={{ marginRight: 16  }}
				>
					{t("toolbar.trainingMode")}
				</Button>
				<Button
					size="small"
					variant="contained"
					onClick={linkHi}
					color="primary"
					style={{ marginRight: 16  }}
				>
					{t("toolbar.connect")}
				</Button>
				<Save 	
					currentDeviceType={currentDeviceType}
					setCurrentDeviceType={setCurrentDeviceType}
				/>
			</Box>
			<Menu
				keepMounted
				open={state.mouseY !== null}
				onClose={handleDelete}
				anchorReference="anchorPosition"
				anchorPosition={
					state.mouseY !== null && state.mouseX !== null
						? { top: state.mouseY, left: state.mouseX }
						: undefined
				}
			>
				<MenuItem onClick={() => handleDelete("left")}>{t("common.delete")}</MenuItem>
			</Menu>
			{linkData.start && (
				<LinkHI
					isLinkHi={linkData.isLinkHi}
					close={() => {
						setLinkData({ ...linkData, start: false });
					}}
					currentDeviceType={currentDeviceType}
					setCurrentDeviceType={setCurrentDeviceType}
					hasPackage={linkData.hasPackage}
					leftStatus={leftStatus}
					setLeftStatus={setLeftStatus}
					rightStatus={rightStatus}
					setRightStatus={setRightStatus}
					fittingDeviceConnectionStatus={fittingDeviceConnectionStatus}
					setFittingDeviceConnectionStatus={setFittingDeviceConnectionStatus}
					training={linkData.training}
				/>
			)}
		</Box>
	);
}
